import {
  Overlay,
  OverlayKeyboardDispatcher,
  OverlayPositionBuilder,
  ScrollStrategyOptions,
  OverlayRef,
  OverlayOutsideClickDispatcher,
} from '@angular/cdk/overlay';
import {
  ComponentFactoryResolver,
  Inject,
  Injector,
  NgZone,
  Renderer2,
  RendererFactory2,
  Injectable,
} from '@angular/core';
import { DS365OverlayContainer } from './overlay-container.service';
import { Directionality } from '@angular/cdk/bidi';
import { DOCUMENT, Location } from '@angular/common';

@Injectable({
  providedIn: 'root',
})
export class DS365Overlay extends Overlay {
  private readonly _DS365OverlayContainer: DS365OverlayContainer;
  private renderer: Renderer2;

  constructor(
    scrollStrategies: ScrollStrategyOptions,
    _overlayContainer: DS365OverlayContainer,
    _componentFactoryResolver: ComponentFactoryResolver,
    _positionBuilder: OverlayPositionBuilder,
    _keyboardDispatcher: OverlayKeyboardDispatcher,
    _injector: Injector,
    _ngZone: NgZone,
    @Inject(DOCUMENT) _document: any,
    _directionality: Directionality,
    rendererFactory: RendererFactory2,
    _location: Location,
    _outsideClickDispatcher: OverlayOutsideClickDispatcher
  ) {
    super(
      scrollStrategies,
      _overlayContainer,
      _componentFactoryResolver,
      _positionBuilder,
      _keyboardDispatcher,
      _injector,
      _ngZone,
      _document,
      _directionality,
      _location,
      _outsideClickDispatcher,
    );
    this.renderer = rendererFactory.createRenderer(null, null);

    this._DS365OverlayContainer = _overlayContainer;
  }

  private setContainerElement(containerElement: HTMLElement): void {
    this.renderer.setStyle(containerElement, 'transform', 'translateZ(0)');
    this._DS365OverlayContainer.setContainerElement(containerElement);
  }

  public createWithDefaultConfig(containerElement?: HTMLElement): OverlayRef {
    if (containerElement) {
      this.setContainerElement(containerElement);
    }
    return super.create({
      panelClass: 'position-absolute',
      backdropClass: 'bg-darker-85',
      positionStrategy: this.position()
        .global()
        .centerHorizontally()
        .centerVertically(),
      scrollStrategy: this.scrollStrategies.block(),
      hasBackdrop: true,
    });
  }
}
